import { IApplicationState, TCardId } from '../../../types/types';
import { getCard } from './getCard';

export const getCardStartDate = (
    state: IApplicationState,
    cardId: TCardId
): number => {
    const card = getCard(state, cardId);
    if (!card) return null;

    return card.startDate;
}
